// src/pages/Identification.js

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signUp, confirmSignUp } from 'aws-amplify/auth';

function Identification() {
  // --- États pour les champs du formulaire ---
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [activationCode, setActivationCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState(''); // Le code envoyé par e-mail
  const [error, setError] = useState('');
  const [step, setStep] = useState('signUp'); // Pour gérer l'étape d'inscription vs confirmation

  const navigate = useNavigate();

  // --- Logique de l'inscription (Étape 1) ---
  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');

    if (email !== confirmEmail) {
      setError("Les adresses e-mail ne correspondent pas.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      // On envoie les données à Cognito en respectant la nouvelle configuration
      await signUp({
        username: email, // On utilise l'email comme username technique pour Cognito
        password: password,
        options: {
          userAttributes: {
            email: email, // L'attribut standard requis
            'custom:activation_code': activationCode, // L'attribut personnalisé
          },
        },
      });
      // Si l'inscription réussit, on passe à l'étape de confirmation
      setStep('confirm');

    } catch (err) {
      setError(err.message);
    }
  };

  // --- Logique de la confirmation (Étape 2) ---
  const handleConfirmSignUp = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await confirmSignUp({
        username: email,
        confirmationCode: verificationCode,
      });
      // Si la confirmation est bonne, on redirige vers la page de connexion
      navigate('/connexion');
    } catch (err) {
      setError(err.message);
    }
  };

  // Le rendu du composant change en fonction de l'étape
  return (
    <section className="login-section">
      <div className="login-container">
          {step === 'signUp' ? (
            // --- Formulaire d'inscription ---
            <>
              <h2>Créer un compte</h2>
              <form className="login-form" onSubmit={handleSignUp}>
                <input type="email" placeholder="Adresse e-mail" aria-label="Adresse e-mail" required value={email} onChange={(e) => setEmail(e.target.value)} />
                
                <input type="email" placeholder="Confirmer l'adresse e-mail" aria-label="Confirmer l'adresse e-mail" required value={confirmEmail} onChange={(e) => setConfirmEmail(e.target.value)} />

                <input type="text" placeholder="Code d'activation (8 caractères)" aria-label="Code d'activation" minLength="8" maxLength="8" required value={activationCode} onChange={(e) => setActivationCode(e.target.value)} />

                <input type="password" placeholder="Mot de passe" required value={password} onChange={(e) => setPassword(e.target.value)} />
                
                <input type="password" placeholder="Confirmer le mot de passe" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />

                {error && <p style={{ color: 'red' }}>{error}</p>}
                <button type="submit">Créer mon compte</button>
              </form>
              <p className="login-footer">
                <span>Déjà inscrit ?</span> <Link to="/connexion">Se connecter</Link>
              </p>
            </>
          ) : (
            // --- Formulaire de confirmation ---
            <>
              <h2>Vérifiez votre compte</h2>
              <p style={{textAlign: 'center', marginBottom: '1rem'}}>Un code a été envoyé à {email}.</p>
              <form className="login-form" onSubmit={handleConfirmSignUp}>
                <input type="text" placeholder="Code de vérification" required value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} />
                
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <button type="submit">Confirmer mon compte</button>
              </form>
            </>
          )}
      </div>
    </section>
  );
}

export default Identification;